import Icon from '../AppIcon';

interface CustomerPortalHeaderProps {
  quoteNumber?: string;
  customerName?: string;
  className?: string;
}

const CustomerPortalHeader = ({
  quoteNumber = 'Q-2024-001',
  customerName = 'Customer',
  className = '',
}: CustomerPortalHeaderProps) => {
  return (
    <header className={`w-full bg-card border-b border-border ${className}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center">
              <img 
                src="/assets/images/Evoqia_Icon_FF-1765449191259.jpeg" 
                alt="Evoqia logo featuring modern abstract geometric shapes with bright lime green and dark charcoal gray elements, representing connectivity and innovation"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-text-primary">Evoqia Quoting</h1>
              <p className="text-sm text-text-secondary">Secure Quote Review Portal</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden md:flex items-center gap-2 px-3 py-2 bg-muted rounded-lg">
              <Icon name="Shield" size={16} className="text-success" />
              <span className="text-sm text-text-secondary">Secure Connection</span>
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-text-primary">{customerName}</p>
              <p className="text-xs text-text-secondary font-mono">{quoteNumber}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CustomerPortalHeader;